export class CarOption{
    constructor(obj) {
        this.id = obj.id;
        this.color = obj.color;
        this.icon = obj.icon;
        this.text = obj.text;
    }
}